/**
 * Deco Stop Bar & Grill brand tokens, mirrored from the public site
 * (dansiegel/seahunt-website → apps/deco-stop/src/styles/global.css @theme).
 * Deliberately a warm teal/coral/sand palette — NOT Sea Hunt Divers' navy & gold.
 */
export const brand = {
  deep: '#0b3b39', // deep teal — dark backgrounds & headings
  sea: '#0e7c7b', // teal — links & primary buttons
  aqua: '#36b9b1', // bright aqua — highlights
  coral: '#ff6b4a', // coral sunset — CTAs & accents
  gold: '#f4b860', // warm amber — badges on dark
  sand: '#faf3e7', // sand — section backgrounds
  haze: '#efe6d6', // warm haze — borders
  ink: '#20251f', // near-black warm — body text
  gray: '#7c7567', // muted warm — secondary text
  /** The logo artwork's own ink, from the SVG. */
  logoInk: '#0b1a23',
  /** Brand off-white, used for the inverted lockup on dark surfaces. */
  logoWhite: '#f1f2f2',
  font: '"Barlow Condensed", ui-sans-serif, system-ui, sans-serif',
} as const;

/**
 * Derived tokens for the always-light sign-in card. Ratios are measured, not estimated —
 * the site's own `bar-gray` (#7c7567) lands at 4.57:1 on white, which clears AA by 0.07 at
 * 12px, so body copy uses a 15%-darker warm gray instead. `bar-coral` (2.82:1) and
 * `bar-aqua` (2.41:1) can never carry meaning on white, so neither appears as text or focus.
 */
export const signIn = {
  abyss: '#062421', // bar-deep × 0.575 — bottom of the water column (teal-derived, not navy)
  muted: '#6b6455', // 5.87:1 on #fff
  accent: brand.sea, // 5.01:1 on #fff, 3.27:1 on abyss — the only token clearing both
  alertBg: '#fef2f2',
  alertTitle: '#7f1d1d', // 9.16:1 on alertBg
  alertBody: '#991b1b', // 7.60:1 on alertBg
} as const;
